// src/pages/Account.tsx
import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import { signout } from "../../services/Signout";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import TopBar from "../TopBar/TopBar"; // Import the TopBar component
import "./Account.scss"; // Add any necessary styles for this page
import { getPPIreports } from "../../services/getPPI";
import PPITable, { PPIReport } from "../../components/PPITable/PPITable";
import { getResearchReports, ResearchReport } from "../../services/getResearch";
import ResearchTable from "../../components/ResearchTable/ResearchTable";

interface AccountProps { }

const Account: React.FC<AccountProps> = () => {
  const navigate = useNavigate();
  const [ppiReports, setPpiReports] = useState<PPIReport[]>([]);
  const [researchReports, setResearchReports] = useState<ResearchReport[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { email } = useUser(); // Get email from context

  const handleLogout = async () => {
    await signout();
    navigate("/signin");
  };

  // useEffect(() => {
  //   console.log("User email in Account component:", email);
  // }, [email]);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        const reports = await getPPIreports();
        setPpiReports(reports);
        const rReports = await getResearchReports();
        setResearchReports(rReports);
      } catch (error) {
        console.error("Failed to fetch reports:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchReports();
  }, []);

  return (
    <div className="account-page">
      <TopBar title="" />
      <div className="account-content">
        <h1>Account</h1>
        <p className="email">{email}</p>
        <div className="button-group">
          <Button type="primary" className="account-button" onClick={handleLogout}>
            Log Out
          </Button>
          <Button type="primary" className="account-button" href="https://app.pacer.co/#/account" target="_blank">
            Profile
          </Button>
        </div>

        <div className="spinner-container">
          <Spin spinning={loading} size="large">
            {ppiReports.length > 0 && <PPITable reports={ppiReports} />}
            {researchReports.length > 0 && <ResearchTable reports={researchReports} />}
          </Spin>
        </div>
      </div>
    </div >
  );
};

export default Account;
